/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Box,
  Typography,
  Popover,
  List,
  ListItem,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import { BiChevronDown } from "react-icons/bi";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: theme.spacing(1.5),
  },
  alignCenterFlex: {
    display: "flex",
    alignItems: "center",
  },
  popoverRoot: {
    marginTop: "-5px",
  },
  listRoot: {
    padding: "0px",
  },
  listItem: {
    fontSize: "16px",
    minWidth: "300px",
    padding: "20px",
    "&::before": {
      content: `""`,
      position: "absolute",
      width: "calc(100% - 30px)",
      height: "1px",
      backgroundColor: "#ECEFF1",
      top: "0",
      left: "15px",
    },
    "&:hover": {
      backgroundColor: "#ECEFF1",
      cursor: "pointer",
    },
    "& > :last-child": {
      marginLeft: "10px",
    },
  },
  filterTitleAndIcon: {
    display: "flex",
    alignItems: "center",
  },
  popoverTitle: {
    padding: "20px",
  },
  selectValueContainer: {
    padding: "5px 10px 5px 10px",
    border: "1px solid #e2e2e2",
    borderRadius: "5px",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    display: "flex",
    flexWrap: "wrap",
    "&:hover": {
      cursor: "pointer",
    },
    "& > :last-child": {
      textTransform: "capitalize",
      marginLeft: "5px",
    },
  },
}));

const StyledBox = withStyles(() => ({
  root: {
    flex: 1,
    direction: "ltr",
    flexDirection: "row",
  },
}))(Box);

const SelectComponent = ({
  selectValue,
  setSelectValue,
  selectOptions,
  selectTitle,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSelectClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (value) => {
    setSelectValue(value);
    setAnchorEl(null);
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div
        role="presentation"
        onClick={handleSelectClick}
        className={classes.selectValueContainer}
      >
        <StyledBox>
          <Typography variant="body1">{selectValue.label}</Typography>
        </StyledBox>

        <Box className={classes.selectValueIcon}>
          <BiChevronDown size={20} />
        </Box>
      </div>
      <Popover
        className={classes.popoverRoot}
        open={Boolean(anchorEl)}
        onClose={handleOnClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {selectTitle === "" ? null : (
          <Box
            component="span"
            className={`${classes.popoverTitle} ${classes.filterTitleAndIcon}`}
          >
            <Typography variant="body1" className={classes.alignCenterFlex}>
              <b>{selectTitle}</b>
            </Typography>
          </Box>
        )}

        <List className={classes.listRoot}>
          {_.map(selectOptions, (option) => {
            return (
              <ListItem
                onClick={() =>
                  handleListItemClick({
                    key: option.key,
                    label: option.label,
                  })
                }
                className={classes.listItem}
                key={option.key}
              >
                {option.icon}
                <Typography variant="body1">{option.label}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
};

export default SelectComponent;
